import React, { useState } from "react";
import Navbar from "./components/Navbar";
import NewsLetter from "./components/NewsLetter";
import "./css/Home.css";
import "./css/CustomModal.css";

import heroBg from "../images/lms-banner.png";
import heroImage from "../images/HomeRightupdated.png";
import heroImage2 from "../images/HomeRight2.png";

// NEW Imports for this section (Update paths to your actual files)
import cardsBg from "../images/Banner2.png";
import cardImg1 from "../images/CardImage1.png";
import cardImg2 from "../images/CardImage2.png";
import cardImg3 from "../images/CardImage3.png";

import { Link } from "react-router-dom";

import twinBg from "../images/Banner3.png"; // New background image asset
import circle2Icon1 from "../images/HomeIcon.png"; // Icon for the first circle
import circle2Icon2 from "../images/HomeIcon.png"; // Icon for the second circle

import dynamicBg from "../images/Banner6.png"; // New background image asset
import thumb1 from "../images/Resources1.jpg";
import thumb2 from "../images/Resources2.png";
import thumb3 from "../images/Resources3.png";
import thumb4 from "../images/Resources4.png";
// Add assets for the expandable cards as well

import Footer from "./components/Footer";

import DownloadAppLMS from "./components/DownloadAppLMS";

function LMS() {

  // Array holding all box content items
  const allBoxes = [
    { id: 1, img: thumb3, title: "CBSE", subtitle: "Class 07 - 10", link: "https://cbse.crestest.com/" },
    { id: 2, img: thumb1, title: "ICSE", subtitle: "Class 07 - 10", link: "https://icse.crestest.com/" },
    { id: 3, img: thumb2, title: "NTSE", subtitle: "Class 10", link: "https://ntse.crestest.com/" },
    { id: 4, img: thumb4, title: "NSTSE", subtitle: "Class 10", link: "https://nstse.crestest.com/" },

    // These hidden boxes will reveal when "View More" is triggered
    // { id: 5, img: thumb5, title: "Cyber Security", subtitle: "Network Protocol", link: "#" },
    // { id: 6, img: thumb6, title: "AI Integration", subtitle: "Machine Models", link: "#" },
  ];

  // State tracker toggles whether all elements show or just the initial 4
  const [showAll, setShowAll] = useState(false);

  // Filters items dynamically based on the toggle state
  const visibleBoxes = showAll ? allBoxes : allBoxes.slice(0, 4);



  return (
    <>
      {/* Existing Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${heroBg})`,
        }}
      >
        <Navbar />

        <div className="container hero-content">
          <div className="row align-items-center">
            {/* Left Section (Increased Width) */}
            <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">
              <div className="hero-left">
                <p className="hero-small-text">AI-Powered Learning Management System</p>

                <h1 className="hero-heading">
                  <span style={{ color: "#FBBB1B" }}>
                    Crestest Premium LMS
                  </span>
                  {" "}for Smarter Learning
                </h1>

                <p className="hero-sub-text" style={{ color: "white" }}>
                  Access comprehensive learning resources, chapter-wise practice, AI-powered
                  assessments, detailed performance analytics, and personalized study support
                  for CBSE & ICSE students—all in one intelligent learning platform.
                </p>

                <a
                  href="https://lms.crestest.com/page-login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn hero-btn"
                >
                  EXPLORE PREMIUM LMS
                </a>
              </div>
            </div>

            {/* Right Section (Circles) */}
            <div className="col-lg-5 col-md-12">
              <div className="hero-right">
                {/* Big Circle Image */}
                <div className="hero-circle-wrapper hero-big-circle">
                  <div className="gradient-border-wrap">
                    <img
                      src={heroImage}
                      alt="Hero Main"
                      className="hero-circle-img"
                    />
                  </div>
                </div>

                {/* Small Overlapping Circle Image */}
                <div className="hero-circle-wrapper hero-small-circle">
                  <div className="gradient-border-wrap">
                    <img
                      src={heroImage2}
                      alt="Hero Secondary"
                      className="hero-circle-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. NEW: Expandable Grid Grid Section */}
      <section
        className="dynamic-grid-section"
        style={{ backgroundImage: `url(${dynamicBg})` }}
      >
        <div className="container">

          {/* Section Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8 d-flex flex-column align-items-center">
              <p className="cards-small-text">CRESTEST OFFERS</p>
              <h2 className="cards-main-heading">The Courses</h2>
              <div className="zigzag-border"></div>
            </div>
          </div>

          {/* Responsive 4-Column Grid Array */}
          <div className="row g-4 justify-content-center transition-grid">
            {visibleBoxes.map((box) => (
              <div className="col-sm-6 col-md-4 col-lg-3" key={box.id}>
                <div className="grid-item-card">
                  <div className="grid-thumb-wrap">
                    <img src={box.img} alt={box.title} className="grid-card-img" />
                  </div>
                  <div className="grid-card-body text-center">
                    <h4 className="grid-title">{box.title}</h4>
                    <p className="grid-subtitle">{box.subtitle}</p>
                    <a href={box.link} className="btn grid-action-btn">
                      VIEW DETAILS
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Expandable Pagination Control Button */}
          {allBoxes.length > 4 && (
            <div className="row mt-5">
              <div className="col-12 text-center">
                <button
                  className="btn view-more-toggle-btn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "SHOW LESS" : "VIEW MORE"}
                </button>
              </div>
            </div>
          )}

        </div>
      </section>




      {/* 6. NEW: Three Cards Section */}
      <section
        className="cards-section"
        style={{ backgroundImage: `url(${cardsBg})` }}
      >
        <div className="container">

          {/* Section Header (Center Aligned) */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8 d-flex flex-column align-items-center">
              <p className="cards-small-text">OUR PROGRAMS</p>
              <h2 className="cards-main-heading">Programs Designed for Academic Success</h2>
              <div className="zigzag-border"></div>
            </div>
          </div>

          {/* Cards Row */}
          <div className="row g-4 justify-content-center">

            {/* Card 1 */}
            <div className="col-md-4">
              <div className="program-card bg-card-yellow">
                <div className="card-img-wrap">
                  <img src={cardImg1} alt="Online Exams" className="card-top-img" />
                </div>
                <div className="card-body-content text-center d-flex flex-column align-items-center">
                  <h3 className="card-heading">Online Exams</h3>
                  <div className="zigzag-border mini-zigzag"></div>
                  <p className="card-sub-text">
                    An intuitive LMS that guides students through self-assessment, personalized learning paths, and online tests to measure progress.
                  </p>
                  <Link to="/online-exam" className="btn glass-btn">
                    LEARN MORE
                  </Link>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-md-4">
              <div className="program-card bg-card-teal">
                <div className="card-img-wrap">
                  <img src={cardImg2} alt="e-Library" className="card-top-img" />
                </div>
                <div className="card-body-content text-center d-flex flex-column align-items-center">
                  <h3 className="card-heading ">e-Library</h3>
                  <div className="zigzag-border mini-zigzag"></div>
                  <p className="card-sub-text ">
                    Access concept maps, notes, webinars, and AI-assisted Q&A that make learning visual, interactive, and engaging.
                  </p>
                  {/* Card 2 */}
                  <Link to="/e-library" className="btn glass-btn glass-btn-dark">
                    LEARN MORE
                  </Link>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-md-4">
              <div className="program-card bg-card-blue">
                <div className="card-img-wrap">
                  <img src={cardImg3} alt="Performance Scorecard" className="card-top-img" />
                </div>
                <div className="card-body-content text-center d-flex flex-column align-items-center">
                  <h3 className="card-heading">Performance Scorecard</h3>
                  <div className="zigzag-border mini-zigzag"></div>
                  <p className="card-sub-text">
                    Track progress with detailed graphs and analytics that highlight strengths, weaknesses, and opportunities for improvement.
                  </p>
                  {/* Card 3 */}
                  <Link to="/performance-scorecard" className="btn glass-btn">
                    LEARN MORE
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Download App Section */}
      <DownloadAppLMS />

      {/* 7. NEW: Overlapping Dual Card Section */}
      <section
        className="twin-cards-section"
        style={{ backgroundImage: `url(${twinBg})` }}
      >
        <div className="container">

          {/* Section Header (Center Aligned) */}
          <div className="row justify-content-center text-center twin-header-margin">
            <div className="col-lg-8 d-flex flex-column align-items-center">
              <p className="cards-small-text">WHY CRESTEST</p>
              <h2 className="cards-main-heading">
                Smarter Learning, Better Results
              </h2>
              <div className="zigzag-border"></div>
            </div>
          </div>

          {/* Dual Cards Row */}
          <div className="row g-5 justify-content-center twin-row-padding">

            {/* Left Card */}
            <div className="col-md-6 col-lg-5">
              <div className="overlap-card">

                <div className="floating-top-circle bg-circle-accent1">
                  <img src={circle2Icon1} alt="AI-Powered Learning" className="floating-circle-icon" />
                </div>

                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                  <p className="overlap-sub-text">
                    Personalized AI-driven learning, smart practice, and detailed performance insights help students strengthen concepts and improve results.
                  </p>
                  <span className="overlap-colored-action">
                    AI-POWERED LEARNING
                  </span>
                </div>

              </div>
            </div>

            {/* Right Card */}
            <div className="col-md-6 col-lg-5">
              <div className="overlap-card">

                <div className="floating-top-circle bg-circle-accent2">
                  <img src={circle2Icon2} alt="Complete Learning Ecosystem" className="floating-circle-icon" />
                </div>

                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                  <p className="overlap-sub-text">
                    From online exams and e-Library resources to performance analytics and academic challenges, Crestest provides a complete learning ecosystem.
                  </p>
                  <span className="overlap-colored-action highlight-action-yellow">
                    COMPLETE ECOSYSTEM
                  </span>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>



      {/* 8. NEW: Modular Newsletter Component */}
      <NewsLetter />

      {/* 9. NEW: Footer Component */}
      <Footer />
    </>
  );
}

export default LMS;